import { TemplatePageProps } from './types'
import { SolitaireSlamEntity } from './entity'
import Icon from 'images/games/solitaire-slam/icon.png'
import Swiper1 from 'images/games/solitaire-slam/swiper1.webp'
import Swiper2 from 'images/games/solitaire-slam/swiper2.webp'
import Swiper3 from 'images/games/solitaire-slam/swiper3.webp'
import Swiper4 from 'images/games/solitaire-slam/swiper4.webp'
import Swiper5 from 'images/games/solitaire-slam/swiper5.webp'
import Swiper6 from 'images/games/solitaire-slam/swiper6.webp'
import Detail1 from 'images/games/solitaire-slam/detail1.png'
import Detail2 from 'images/games/solitaire-slam/detail2.png'
import Detail3 from 'images/games/solitaire-slam/detail3.png'
import Footer from 'images/games/solitaire-slam/footer.png'
import { SolitaireClashLink, SolitaireInfiniteLink, SolitaireVentureLink } from '../../components'

export const SolitaireSlamDetail: TemplatePageProps = {
  entity: {
    ...SolitaireSlamEntity,
    logo: Icon,
    title: (
      <>
        Solitaire Slam: Elevate Your <strong>Solitaire Collection</strong>
      </>
    ),
    description: (
      <>
        Get ready for <strong>Solitaire Slam</strong>—a fast-paced twist on the <strong>classic Solitaire game</strong>!
        Play skill-based matches, unlock epic rewards, and join competitive 1 on 1 or multiplayer tournaments. With fun
        minigames, exciting events, and real cash prizes up for grabs, it&#39;s time to download and start slamming!
      </>
    ),
  },
  swiper: [
    { image: Swiper1 },
    { image: Swiper2 },
    { image: Swiper3 },
    { image: Swiper4 },
    { image: Swiper5 },
    { image: Swiper6 },
  ],
  content: [
    {
      title: <>How to Play Solitaire Slam</>,
      description: (
        <>
          <strong>Solitaire Slam</strong> delivers a fast, skill-based gameplay on the traditional Solitaire experience.
          Sort cards in the tableau by alternating colors in descending order to reveal hidden cards and build your{' '}
          <strong>Solitaire strategy</strong>. Use the stock to draw three cards at a time into the waste pile, keeping
          in mind that repeated cycles reduce your score after the third go, so play wisely! Move cards to the
          foundation stacks in ascending order by suit to solve the deck and earn bonuses. Can’t solve it all? End the
          match early for a bonus <strong>solitaire time</strong>! With quick thinking and solid strategy, every move
          counts in Solitaire Slam. Get ready to stack, sort, and slam your way to victory!
        </>
      ),
      image: Detail1,
    },
    {
      title: <>Inside This Free Solitaire Game</>,
      description: (
        <>
          <strong>Solitaire Slam</strong> turns your <strong>solitaire skills</strong> into a mix of fun, skill-based
          cash matches. Play free matches using tickets to sharpen your strategy, or enter cash tournaments with
          different number of players. Try minigames like Bingo of Oz, Sphinx’s Fortune, and Pirate’s Plunder for fresh
          twists on gameplay. Claim free in-game items through Lucky Box, Spin & Win, and Scratch & Win. Plus,
          limited-time events like Honey Haul and Charm Chase keep the action fresh and rewarding. With so many ways to
          play, Solitaire Slam keeps the excitement going!
        </>
      ),
      image: Detail2,
    },
    {
      title: <>Reliable Payment Solutions for Every Player</>,
      description: (
        <>
          Avia ensures that your experience is secure with advanced encryption that safeguards your gameplay and
          personal information. Enjoy fast cashouts for your winnings with <strong>PayPal</strong> and easy deposits
          through trusted partners like <strong>PayPal</strong>, <strong>Venmo</strong>, <strong>Apple Pay</strong>,{' '}
          <strong>Visa</strong>, <strong>Mastercard</strong>, <strong>Amex</strong>, and <strong>Discover</strong>.
          Everything is set up so you can easily enjoy your matches!
        </>
      ),
      image: Detail3,
    },
    {
      title: <>Compete, Slam, and Win!</>,
      description: (
        <>
          <strong>Solitaire Slam</strong> is a fresh take on the <strong>traditional card game</strong>, blending
          fast-paced gameplay with competitive, skill-based matches. Use tickets to practice for free, then compete in
          cash tournaments for real money rewards. Enjoy exciting minigames and weekly events that keep the fun going.
          With secured and fast payment methods, Solitaire Slam makes every step simple!
          <br />
          <br />
          Download Solitaire Slam now and try other solitaire games from <strong>Avia</strong> like{' '}
          <SolitaireClashLink strong />, <SolitaireInfiniteLink strong />, or <SolitaireVentureLink strong /> for a
          diverse, skill-based solitaire experience!
        </>
      ),
    },
  ],
  footer: {
    image: Footer,
  },
} as TemplatePageProps
